import React, { useState, useEffect } from 'react';
import userIcon from '../../../assets/images/user-icon.png'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';


import Axios from "axios";
import { Link } from 'react-router-dom';
import { userDetailHeader } from '../../../store/actions/userDataActions';
import { toast } from 'react-toastify';

import {
    checkProfileImageExistence,
    uploadProfilePicture,
    removeProfileData
  } from "../../../store/actions/userActions";




export default function ProfileDropdown() {
    const [userId, setuserId] = useState('');
    const [userName, setuserName] = useState('');
    const [userEmail, setuserEmail] = useState('');
    const dispatch = useDispatch()
    const { userData, userFlag } = useSelector((state) => state.userDataHeader)

    
    const { loggedInUserDetail, isAddingUser } = useSelector(
        (state) => state.userData
      );

    useEffect(() => {
        if (userFlag == false) {
            checkToken(localStorage.getItem('token_id'));
            dispatch(userDetailHeader());

        } else {

            userData&&userData.forEach(element => {
                let mp = JSON.parse(element.module_permissions)
                window.modulePermissions.M1.view = (mp?.M1?.view == 1) ? 1 : window.modulePermissions.M1.view;
                window.modulePermissions.M1.add = (mp?.M1?.add == 1) ? 1 : window.modulePermissions.M1.add;
                window.modulePermissions.M1.edit = (mp?.M1?.edit == 1) ? 1 : window.modulePermissions.M1.edit;
                window.modulePermissions.M1.del = (mp?.M1?.del == 1) ? 1 : window.modulePermissions.M1.del;
                window.modulePermissions.M2.view = (mp?.M2?.view == 1) ? 1 : window.modulePermissions.M2.view;
                window.modulePermissions.M3.view = (mp?.M3?.view == 1) ? 1 : window.modulePermissions.M3.view;
                window.modulePermissions.M3.add = (mp?.M3?.add == 1) ? 1 : window.modulePermissions.M3.add;
                window.modulePermissions.M3.edit = (mp?.M3?.edit == 1) ? 1 : window.modulePermissions.M3.edit;
                window.modulePermissions.M3.del = (mp?.M3?.del == 1) ? 1 : window.modulePermissions.M3.del;
                window.modulePermissions.M4.view = (mp?.M4?.view == 1) ? 1 : window.modulePermissions.M4.view;
                window.modulePermissions.M4.add = (mp?.M4?.add == 1) ? 1 : window.modulePermissions.M4.add;
                window.modulePermissions.M4.edit = (mp?.M4?.edit == 1) ? 1 : window.modulePermissions.M4.edit;
                window.modulePermissions.M4.del = (mp?.M4?.del == 1) ? 1 : window.modulePermissions.M4.del;
                window.modulePermissions.M5.view = (mp?.M5?.view == 1) ? 1 : window.modulePermissions.M5.view;
                window.modulePermissions.M5.add = (mp?.M5?.add == 1) ? 1 : window.modulePermissions.M5.add;
                window.modulePermissions.M5.edit = (mp?.M5?.edit == 1) ? 1 : window.modulePermissions.M5.edit;
                window.modulePermissions.M5.del = (mp?.M5?.del == 1) ? 1 : window.modulePermissions.M5.del;

            });
            profileload(userData&&userData[0]?.email) 
            // console.log(window.modulePermissions)
        }
    }, [userFlag])

    function logout() {
        Axios.get(process.env.REACT_APP_NODE_API_URL + "/users/logout", {
        }).then((response) => {
            if (response.status == 200) {
                localStorage.setItem('token_id', '');
                toast.success("Logout Successfully");
                window.location = '/';
            } else {
                toast.error("Logout Failed");
            } 
        });
    }


    const [profilename, setprofilename] = useState('')
    const [profile, setprofile] = useState(false)
    const { profileImageExistenceStatus, profileImage } = useSelector((state) => state.userData)
    const profilePicture = useSelector(state => state.userData.profilePicture);

    useEffect(() => {
        if (profilePicture) {
            setprofilename(profilePicture)
            setprofile(profileImageExistenceStatus)
        }
    }, [profilePicture, profileImageExistenceStatus]);
  
    useEffect(() => {
        if (profileImage){  
            setprofilename(profileImage)
            setprofile(profileImageExistenceStatus)
        }
    }, [profileImage, profileImageExistenceStatus]);

    // useEffect(() => {
    //     if (userData) {
    //      dispatch(checkProfileImageExistence(userData[0]?.email));
    //     }
    //  }, []);

    const profileload = (email) =>{
        Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/profileimage", {
        email: email
      }).then((response) => {
          if (response.data.response == 200) {
              setprofile(response.data.status)
              setprofilename(response.data.profileImages)
          } else {
               setprofile(false)
               setprofilename(response.data.profileImages)
          } 
      });
    }

    const checkToken = async (token_id) => {
        // fetch(process.env.REACT_APP_NODE_API_URL + `/auth/getTokenData?token_id=` + token_id)
        //     .then(res => res.json())
        //     .then(
        //         (result) => {

        //             console.log(result);
        //             setuserId(result.id);
        //             setuserName(result.name);
        //             setuserEmail(result.email);
        //         },
        //         (error) => {
        //             console.log('error', error)
        //             alert("1 token not verified, or expired, Login Again");
        //             // window.location = '/';
        //         }
        //     )

    }
    return (
        <div className="dropdown profile-dropdown d-flex">
            <button type="button" id="dropdownprofile" data-bs-toggle="dropdown" aria-expanded="false">
                <div className="profile-info">
                    <div className="profileName">
                        {userData&&userData[0]?.name}
                    </div>
                    <div className="profle-desi">
                        {userData&&userData[0]?.email}
                    </div>
                </div>
                {/* <img src={userIcon} alt="" width={45} height={45} className="ms-2" /> */}
                <img src={profile ? process.env.REACT_APP_NODE_API_URL+"/image/"+profilename :userIcon} alt="profile-img" width={45} height={45} className="ms-2"/> 
                <svg width={10} height={8} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.8002 1.5998C9.8002 1.1598 9.4402 0.799805 9.0002 0.799805H1.0002C0.560195 0.799805 0.200195 1.1598 0.200195 1.5998C0.200195 1.7918 0.280195 1.9678 0.392195 2.1038L0.384195 2.1118L4.38419 6.9118L4.3922 6.9038C4.5442 7.0798 4.7522 7.1998 5.0002 7.1998C5.2482 7.1998 5.4562 7.0798 5.6082 6.9038L5.6162 6.9118L9.6162 2.1118L9.6082 2.1038C9.7202 1.9678 9.8002 1.7918 9.8002 1.5998Z" fill="#E60000" />
                </svg>

            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownprofile">
                <li><Link className="dropdown-item" to="/admin/settings/profile">Edit Profile</Link></li>
                {/* <li><a className="dropdown-item" href="">{}</a> </li> */}
                {/* <div className="dropdown-divider"></div> */}
                <li><a className="dropdown-item" onClick={logout}>Logout</a> </li>
            </ul>
        </div>
    )
}
